import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

const ToolTipWrapper = styled.div`
  display: none;
  transition: opacity .2s ease-in-out;
  position: absolute;
  background: #000;
  color: #fff;
  font-size: 14px;
  line-height: 16px;
  border-radius: 4px;
  padding: 6px 7px;
  white-space: nowrap;
  z-index: 20100;
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.2);

  &::before {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
  }

  &[arrowPosition="left"] {
    transform: translateY(-50%);
    margin: 0 11px;

    &::before {
      left: -9px;
      border-right: 10px solid #000;
    }
  }

  &[arrowPosition="right"] {
    transform: translate(calc(-100% - 11px), -50%);
    margin: 0 11px 0 0;

    &::before {
      right: -9px;
      border-left: 10px solid #000;
    }
  }

  &[arrowPosition="left"]::before,
  &[arrowPosition="right"]::before {
    top: 5px;
    border-bottom: 9px solid transparent;
    border-top: 9px solid transparent;
  }

  &[arrowPosition="bottom"] {
    transform: translate(-50%, calc(-100% - 11px));
    margin: 0 0 11px;

    &::before {
      bottom: -9px;
      border-top: 10px solid #000;
    }
  }

  &[arrowPosition="top"] {
    transform: translateX(-50%);
    margin: 11px 0;
  }

  &[arrowPosition="bottom"]::before,
  &[arrowPosition="top"]::before {
    left: calc(50% - 9px);
    border-left: 9px solid transparent;
    border-right: 9px solid transparent;
  }

  &[arrowPosition="topright"] {
    transform: translateX(calc(-100% - 18.5px));
    margin: 11px 0;

    &::before {
      right: 10px;
      border-left: 9px solid transparent;
      border-right: 9px solid transparent;
    }
  }

  &[arrowPosition="topright"]::before,
  &[arrowPosition="top"]::before {
    top: -9px;
    border-bottom: 10px solid #000;
  }
`

const ToolTip = ({ id, text = '', arrowPosition = 'bottom', className }) => {
  return <ToolTipWrapper id={id} arrowPosition={arrowPosition} data-cy='ToolTipComponent'>{text}</ToolTipWrapper>
}

ToolTip.propTypes = {
  text: PropTypes.string,
  arrowPosition: PropTypes.oneOf(['bottom', 'left', 'right', 'top', 'topright'])
}

export default ToolTip
